import { useContext, useEffect, useState } from 'react'
import { MarkupContext } from '../../providers/Markup'
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/solid'
import ButtonEl from '../helpers/ctas/Button'
import SearchForm, { useSearchForm } from './SearchForm'

function Search(props) {
  const triggerTheme = 'none'
  const { detectPaletteClass } = useContext(MarkupContext)
  const [searchActive, setSearchActive] = useState()
  const { searchTerm, setSearchTerm, submitForm } = useSearchForm()

  useEffect(() => {
    const handler = (evt) => {
      if (!evt.target.closest('[data-type="search"]') && !evt.target.closest('[data-type="searchForm"]')) {
        setSearchActive(false)
      }
    }
    document.addEventListener('click', handler)
    return () => document.removeEventListener('click', handler)
  }, [])

  const triggerContent = (
    <>
      <MagnifyingGlassIcon
        className={detectPaletteClass(
          `${searchActive ? 'hidden' : 'block'} h-6 w-6 !text-(--sb-search-icon-color) text-base`,
        )}
        role="none"
      />
      <XMarkIcon
        className={detectPaletteClass(
          `${searchActive ? 'block' : 'hidden'} h-6 w-6 !text-(--sb-search-icon-color) text-base`,
        )}
        role="none"
      />
      <span className="sr-only">Toggle search field</span>
    </>
  )
  useEffect(() => {
    setSearchActive((prevState) => (props.menuActive === true || props.ctasActive === true ? false : prevState))
  }, [props.menuActive, props.ctasActive])

  const handleSearchClick = (evt) => {
    setSearchActive((prevState) => {
      const isActive = !prevState
      props.setSearchActive(isActive)
      props.setMenuActive((prevState) => {
        let newState = prevState
        if (isActive === true) {
          // is search has become active turn the menu off
          newState = false
        }
        // otherwise do nothing.
        props.setCtasActive(newState)
        return newState
      })
      return isActive
    })
  }

  return (
    <>
      <div
        data-type="search"
        className={`basis-1/10 self-center ml-auto md:ml-3 peer/trigger ${searchActive && (props.menuActive === false || props.menuActive === undefined) ? 'active' : 'inactive'}`}
      >
        <ButtonEl theme={triggerTheme} className="px-0! shadow-none!" onClick={handleSearchClick} buttonType="default">
          {triggerContent}
        </ButtonEl>
      </div>
      <div
        data-type="searchForm"
        className={`group/wrapper ${searchActive ? 'active' : 'inactive'} w-full flex justify-center peer-[.inactive]/trigger:h-0 transition-all z-50 duration-500 peer-[.active]/trigger:h-[100px] md:peer-[.active]/trigger:h-[100px] overflow-hidden flex-nowrap`}
      >
        <SearchForm
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          onSubmit={submitForm}
          isActive={searchActive}
          formId="main-nav-search"
          placeholder="Enter search terms"
          formClassName={`group/form shadow-md ${searchActive ? 'active' : 'inactive'} container py-4 mb-4 max-md:px-8 md:px-12 basis-10/12 md:basis-7/12 bg-(--sb-search-box-bg) rounded-b-md`}
          innerClassName="group-[.active]/form:opacity-100 group-[.inactive]/form:opacity-0 transition-all duration-300 group-[.active]/form:delay-500"
          buttonClassName="text-white"
        />
      </div>
    </>
  )
}

export default Search
